import { BrowserRouter, Route, Routes } from "react-router-dom";
import RootLayout from "../layouts/RootLayout";
import PrivateRoutes from "./PrivateRoutes";
import SignInPage from "../pages/SignInPage";
import SignUpPage from "../pages/SignUpPage";
import ShopifyPage from "../pages/ShopifyPage";
import { AppRoutes } from "../routes";
import ImprintPage from "../pages/ImprintPage";
import CustomProductGeneratorPage from "../pages/CustomProductGeneratorPage";
import AdminCenterPage from "../pages/AdminCenterPage";
import HomeRedirect from "../pages/HomeRedirect";
import BrandResearchPage from "../pages/BrandResearchPage";

export const AppRouter: React.FC = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route key="protected-routes" element={<PrivateRoutes />}>
                    <Route key="home-page-layout" element={<RootLayout />}>
                        <Route path={AppRoutes.home} element={<HomeRedirect />} />
                        <Route path={AppRoutes.shopify} element={<ShopifyPage />} />
                        <Route path={AppRoutes.customProductGenerator} element={<CustomProductGeneratorPage />} />
                        <Route path={AppRoutes.brandResearch} element={<BrandResearchPage />} />
                        <Route path={AppRoutes.adminCenter} element={<AdminCenterPage />} />
                    </Route>
                </Route>
                <Route index path={AppRoutes.signIn} element={<SignInPage />} />
                <Route path={AppRoutes.signUp} element={<SignUpPage />} />
                <Route path={AppRoutes.imprint} element={<ImprintPage />} />
            </Routes>
        </BrowserRouter>)
}
